/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

const numberRegex = /(\d+((,|.)\d+)?)/;

export function displayIfNotZero(input) {
    if (typeof input === "number") {
        return input !== 0;
    }

    let number = input && (numberRegex.exec(input)[1] || '0');
    number = number.replace(",", ".");

    return !isNaN(parseFloat(number)) && parseFloat(number) !== 0;
}
